export default {
  SET_SUBPROYECTOS (state, subproyectos) {
    state.subproyectos = subproyectos
  },
  ID_SUBPROYECTO_MODIFICADO (state, id) {
    state.idSubproyectoModificado = id
  }
}
